import { Action, ThunkDispatch, configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { useDispatch } from "react-redux";
import agentCopilotApi from "./apis/agentCopilotApi.ts";
import blenderApi from "./apis/blenderApi";
import frontendConfigStoreApi from "./apis/frontendConfigStoreApi";
import workflowApi from "./apis/workflowApi";
import authSlice from "./authSlice";

export const store = configureStore({
  reducer: {
    [authSlice.name]: authSlice.reducer,
    [agentCopilotApi.reducerPath]: agentCopilotApi.reducer,
    [blenderApi.reducerPath]: blenderApi.reducer,
    [frontendConfigStoreApi.reducerPath]: frontendConfigStoreApi.reducer,
    [workflowApi.reducerPath]: workflowApi.reducer,
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(
    agentCopilotApi.middleware,
    blenderApi.middleware,
    frontendConfigStoreApi.middleware,
    workflowApi.middleware,
  ),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, unknown, Action>;
export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
